<div
    [style.display]="selected ? '' : 'none'"
    class="personalizationTab"
>
    <div
        *ngIf="distributionId"
        class="personalizationTab-container"
    >
        <ng-container *ngFor="let summary of personalizationSummary">
            <agpr-personalization-detail-card
                [label]="'Discover.personalizationTag.' + summary.tagType"
                [value]="summary.totalPersonalizations"
                [maxValue]="summary.totalRecipients"
            ></agpr-personalization-detail-card>
        </ng-container>
    </div>
</div>
